import { useEffect, useState } from "react";

const RISE_S = 40;
const FALL_S = 8;

export const DroneShade = () => {
  const [level, setLevel] = useState(0);
  useEffect(() => {
    let v = 0;
    const id = setInterval(() => {
      const target = window.__ambientOn ? 1 : 0;
      const rate = target > v ? 0.25 / (RISE_S * (window.__ambientScale || 1)) : 0.25 / FALL_S;
      v = target > v ? Math.min(target, v + rate) : Math.max(target, v - rate);
      window.__droneShade = v;
      document.documentElement.style.setProperty("--drone", v.toFixed(3));
      setLevel(Math.round(v * 100) / 100);
    }, 250);
    return () => clearInterval(id);
  }, []);
  return <div className="drone-shade" data-testid="drone-shade" data-level={level} style={{ opacity: level }} aria-hidden="true" />;
};
